module.exports = __webpack_public_path__ + "img/ban_05.d2350e72.png";